import React from 'react';
import { IconProps } from '.';

const SvgZdsNotice = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 32 32'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M6 20v-8l16-6v20L6 20Zm14.5 3.835-13-4.875v-5.92l13-4.875v15.67Z'
        clipRule='evenodd'
      />
      <path fill={color} d='M24.25 13v6h1.5v-6h-1.5Z' />
    </svg>
  );
};

export default SvgZdsNotice;
